module.exports = {
    alisonJS: process.env.VUE_APP_ALISON_JS,
    alisonGUI: process.env.VUE_APP_ALISON_GUI,

		// APi de TadServer backend
    tadServerApiUrl: process.env.VUE_APP_TAD_SERVER_API_URL,
    tadServerUseClientKey: process.env.VUE_APP_TAD_SERVER_USE_CLIENT_KEY,
    tadServerUseClientSecret: process.env.VUE_APP_TAD_SERVER_USE_CLIENT_SECRET,
    tadServerTenant: process.env.VUE_APP_TAD_SERVER_TENANT,
    tadServerSeat: process.env.VUE_APP_TAD_SERVER_SEAT,

    // APi de AlisonServer backend
    alisonServerApiUrl: process.env.VUE_APP_ALISON_SERVER_API_URL,
    webauthnUserPanelUrl: process.env.VUE_APP_USER_PANEL_URL,
    alisonServerGenClientKey: process.env.VUE_APP_ALISON_SERVER_GEN_CLIENT_KEY,
    alisonServerGenClientSecret: process.env.VUE_APP_ALISON_SERVER_GEN_CLIENT_SECRET,
    alisonServerUseClientKey: process.env.VUE_APP_ALISON_SERVER_USE_CLIENT_KEY,
    alisonServerUseClientSecret: process.env.VUE_APP_ALISON_SERVER_USE_CLIENT_SECRET,
    alisonServerTenant: process.env.VUE_APP_ALISON_SERVER_TENANT,
    alisonServerSeat: process.env.VUE_APP_ALISON_SERVER_SEAT

}
